module.exports = __webpack_public_path__ + "img/date-time.05bd43a3.jpeg";